<template>
  <div class="maintain" v-if="funcView.maintain_maintenance_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="onAdd" v-if="funcView.maintain_maintenance_add">{{$t('Common.com_add')}}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.maintain_maintenance_export" style="float: right; margin-right: 0">
          <el-button class="table-set">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :style="{ 'margin-right': !funcView.maintain_maintenance_export ? 0 : '' }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('asm_maintain.bao_yang_xiang_mu')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
            @change="onPageChange({ page: 1 })"
            @getList="initProductCode"
            :placeholder="$t('asm_maintain.chan_pin_xing_hao')"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" @filter="filterChange" @sort="sortChange" :slots="['itemName', 'action']" :column="tableColumn">
        <template v-slot:itemName="scope">
          <span class="watch-detail" @click="watchDetail(scope.row)" v-if="funcView.maintain_maintenance_view">{{ scope.row.itemName }}</span>
          <span v-else>{{ scope.row.itemName }}</span>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" @click="onEdit(scope.row)" v-if="funcView.maintain_maintenance_edit">{{$t('Common.com_edit')}}</el-button>
          <el-button type="text" size="mini" @click="onDel(scope.row)" v-if="funcView.maintain_maintenance_delete">{{$t('Common.com_delete')}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <maintain-item-dialog v-if="dialog1Visible" @close="dialog1Visible = false" :model="dialog1Model" @success="onPageChange({ page: 1 })"></maintain-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import maintainItemDialog from './maintain_item_dialog';

export default {
  name: '',
  mixins: [],
  components: {
    maintainItemDialog,
  },
  props: {
    form: [Object],
  },
  data() {
    return {
      tableCode: 'maintain_manage',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
      },
      totalRows: null,
      tableList: [],
      productCodes: [],
      // 新增编辑项目
      dialog1Model: {},
      dialog1Visible: false,
    };
  },
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.BasicItemPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    initProductCode(list) {
      this.productCodes = list;
      // if (list.length) {
      //   this.formSearch.productCode = list[0].productCode;
      //   this.getTableList();
      // }
    },
    // 查看保养详情
    watchDetail(row) {
      this.jump('/paramSet/maintainManage/maintain_item_watch', {
        productCode: row.productCode,
      });
    },
    delProject(row) {
      return this.$postJSON(`${apis.BasicItemDelete}/${row.itemId}`, {}, true);
    },
    onEdit(row) {
      this.dialog1Model = {
        title: this.$t('Common.com_edit'),
        type: 'edit',
        data: row,
      };
      this.dialog1Visible = true;
    },
    onAdd() {
      this.dialog1Model = {
        title: this.$t('Common.com_add'),
        type: 'add',
      };
      this.dialog1Visible = true;
    },
    onDel(row) {
      this.$showConfirm(this.$t('asm_maintain.nqdyscxzdbyxm')).then(() => {
        this.delProject(row).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.getTableList();
        });
      });
    },
  },
  created() {},
  mounted() {
    this.formSearch.search = this.form.search;
    this.formSearch.productCode = this.form.productCode;
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
  },
};
</script>

<style lang="scss" scoped>
.maintain {
  padding: 0 16px 0 16px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .watch-detail {
    text-decoration: underline;
    cursor: pointer;
    color: #0d9ae0;
  }
}
</style>
